import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ImageUploading from "react-images-uploading";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Modal from "react-modal";
import { toast } from "react-toastify";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import SelectDropdown from "../components-react/SelectDropdown";
import { fetchExpenseCategoriesData } from "../../redux/hygiene-reducers/hygieneSlice";
import {
  expense_payment_options,
  expense_types,
  expense_payee_options,
  image_pdf,
} from "../common-data/DropdowData";
import { selectGymData } from "../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../data/APIs";
import { fetchVendors } from "../../data/dropdownApiS";
import ExpenseCatForm from "./ExpenseCatForm";
import VendorForm from "./VendorForm";
import { commonPostPutFormData } from "../../redux/reducers/commonApiSlice";
import {
  add_expense_request,
  update_expense_request,
} from "../../data/ApiEndpoints";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { uploadImage } from "../../redux/reducers/postApiSlice";
import { formatWTFString } from "../common-data/Conversions";
import {
  CloudUploadIcon,
  CloudPlusIcon,
  DeleteIcon,
} from "../../images/icons/icons";
import "../../styles/expense-management/ExpenseForm.css";
const maxNumber = 1;

function validateExerciseForm(formValues, formImages, isEdit, userInfoData) {
  let errors = {};

  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  if (!formValues.selectedExpenseCat) {
    errors.selectedExpenseCat = "required";
  }

  if (!formValues.selectedExpenseType) {
    errors.selectedExpenseType = "required";
  }

  if (
    formValues.selectedExpenseType?.value === "gym" &&
    !formValues.selectedGym
  ) {
    errors.selectedGym = "required";
  }

  if (!formValues.selectedPayee) {
    errors.selectedPayee = "required";
  }

  if (
    formValues.selectedPayee?.value === "vendor" &&
    !formValues.selectedVendor
  ) {
    errors.selectedVendor = "required";
  }

  if (!formValues.requestedAmount) {
    errors.requestedAmount = "required";
  }

  if (!formValues.requestedDescription) {
    errors.requestedDescription = "required";
  } else if (isClusterManager && formValues.requestedDescription?.length < 10) {
    errors.requestedDescription = "required";
  } else if (
    !isClusterManager &&
    formValues.requestedDescription?.length < 20
  ) {
    errors.requestedDescription = "required";
  }

  if (formValues.selectedPaymentMethod?.value === "upi" && !formValues.uidId) {
    errors.uidId = "required";
  }

  if (
    formValues.selectedPaymentMethod?.value === "bank" &&
    !formValues.ifscCode
  ) {
    errors.ifscCode = "required";
  }

  if (
    formValues.selectedPaymentMethod?.value === "bank" &&
    !formValues.accountNo
  ) {
    errors.accountNo = "required";
  }

  if (
    formValues.selectedPaymentMethod?.value === "qr" &&
    Number(formValues.requestedAmount || 0) > 2000
  ) {
    errors.selectedPaymentMethod = "required";
    errors.requestedAmount = "required";
  }

  if (
    !isEdit &&
    formValues.selectedPaymentMethod?.value === "qr" &&
    formImages.paymentRequestedImg?.length === 0
  ) {
    errors.paymentRequestedImg = "required!";
  }

  // Only validate bill image if not petty cash category
  if (
    !isEdit &&
    formValues.selectedExpenseCat?.info?.is_petty_cash !== 1 &&
    (!formValues.selectedDocumentUploadType ||
      formValues.selectedDocumentUploadType?.value === "image") &&
    formImages.requestedImg?.length === 0
  ) {
    errors.requestedImg = "required!";
  } else if (
    !isEdit &&
    formValues.selectedExpenseCat?.info?.is_petty_cash !== 1 &&
    formValues.selectedDocumentUploadType?.value === "pdf" &&
    !formImages.paymentRequestedPdf
  ) {
    errors.requestedImg = "required!";
  }

  return errors;
}

const ExpenseForm = ({
  userInfoData,
  isEdit,
  rowData,
  closeModal,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);
  const { expenseCategories } = useSelector((state) => state.hygiene);
  const { postPutLoadingFormData } = useSelector((state) => state.common);

  const isAdmin = userInfoData?.account_type === "admin";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";
  const isGym = userInfoData?.account_type === "gym";
  const isReceptionist =
    userInfoData?.account_type === "receptionist" ||
    userInfoData?.account_type === "trainer";

  const isExpenseCategoryAccess =
    userInfoData?.email === "vn@wtfgyms.com" ||
    userInfoData?.email === "arpit@wtfup.me" ||
    userInfoData?.email === "anita@wtfup.me" ||
    userInfoData?.email === "accounts.team@wtfgyms.com" ||
    userInfoData?.email === "naresh.kukreti@wtfup.me" ||
    userInfoData?.email === "mousumi.malik@wtfup.me";

  const iniModvalues = {
    isModOpen: false,
    cardName: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);
  const [allCategoriesData, setAllCategoriesData] = useState([]);
  const [allVendorsData, setAllVendorsData] = useState([]);
  const forminitials = {
    selectedExpenseCat:
      isEdit && rowData?.expense_category && rowData?.expense_category_name
        ? {
            label: rowData.expense_category_name,
            value: rowData.expense_category,
          }
        : isClusterManager
        ? null // Will be auto-selected to petty cash category when categories load
        : "", // Empty for all other user types to manually select
    selectedExpenseType:
      !isAdmin && !isClusterManager
        ? expense_types[0]
        : isClusterManager
        ? expense_types[1]
        : isEdit && rowData?.expense_type
        ? {
            label: formatWTFString(rowData.expense_category_name),
            value: rowData.expense_type,
          }
        : "",
    selectedGym:
      (!isAdmin && !isClusterManager) || isReceptionist
        ? (() => {
            if (isReceptionist && userInfoData?.gym_id) {
              // For receptionists, find gym from gymData using gym_id
              const matchingGym = gymData?.find(
                (gym) => gym.value === userInfoData.gym_id
              );
              return matchingGym || "";
            } else {
              // For regular gym users
              return {
                label: isGym
                  ? userInfoData?.name
                  : userInfoData?.gym_name || "",
                value:
                  userInfoData?.gym_id ||
                  userInfoData?.user_id ||
                  userInfoData?.uid ||
                  "",
              };
            }
          })()
        : isEdit && rowData?.gym_id && rowData?.gym_name
        ? {
            label: rowData.gym_name,
            value: rowData.gym_id,
          }
        : "",
    selectedPayee:
      isEdit && rowData?.payee_type
        ? {
            label: rowData.payee_type === "self" ? "Self" : "Vendor",
            value: rowData.payee_type,
          }
        : "",
    selectedVendor:
      isEdit && rowData?.vendor_uid && rowData?.vendor_name
        ? {
            label: rowData.vendor_name,
            value: rowData.vendor_uid,
          }
        : "",
    requestedAmount:
      isEdit && rowData?.requested_amount ? rowData.requested_amount : "",
    requestedDescription:
      isEdit && rowData?.requested_description
        ? rowData.requested_description
        : "",
    selectedPaymentMethod:
      isEdit && rowData?.payment_method
        ? {
            label: rowData.payment_method,
            value: rowData.payment_method,
          }
        : "",
    uidId: isEdit && rowData?.upi_id ? rowData.upi_id : "",
    ifscCode: isEdit && rowData?.ifsc_code ? rowData.ifsc_code : "",
    accountNo: isEdit && rowData?.account_number ? rowData.account_number : "",
    paymentRequestedImg:
      isEdit && rowData?.payment_method_img ? rowData.payment_method_img : "",
    requestedImg: isEdit && rowData?.requested_img ? rowData.requested_img : "",
    selectedDocumentUploadType:
      isEdit &&
      rowData?.requested_img &&
      rowData.requested_img?.toLowerCase().endsWith(".pdf")
        ? image_pdf[1]
        : image_pdf[0],
    paymentRequestedPdf: "",
  };
  const [formValues, setFormValues] = useState(forminitials);
  const imgVdoInitials = {
    paymentRequestedImg:
      isEdit && rowData?.payment_method_img
        ? [{ data_url: rowData.payment_method_img }]
        : [],
    requestedImg:
      isEdit && rowData?.requested_img
        ? [{ data_url: rowData.requested_img }]
        : [],
  };
  const [formImages, setFormImages] = useState(imgVdoInitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  function getExpenseCategories() {
    const filters = {
      page: 1,
      limit: 3000,
      status: "active",
      is_petty_cash: isClusterManager ? "1" : "0",
      is_gym_expense: isReceptionist ? "1" : "",
    };

    dispatch(
      fetchExpenseCategoriesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  async function getVendors() {
    try {
      const filters = {
        page: 1,
        limit: 1000,
        status: "active",
        gym_id: formValues.selectedGym?.value || "",
      };
      const vendors = await fetchVendors(filters, userInfoData?.token);
      setAllVendorsData(vendors || []);
    } catch (error) {
      console.error("Error fetching vendors:", error);
      setAllVendorsData([]);
    }
  }

  useEffect(() => {
    if (formValues.selectedGym?.value) {
      getVendors();
    }
  }, [formValues.selectedGym]);

  const onChangeInput = (e) => {
    setIsSubmit(false);

    const { name, value, type, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onChangeTextInput = (content, fieldName) => {
    setIsSubmit(false);
    setFormValues((prev) => ({ ...prev, [fieldName]: content }));
  };

  const onChangeDropdown = (value, name) => {
    setIsSubmit(false);

    if (name === "selectedPaymentMethod") {
      setFormValues({
        ...formValues,
        uidId: "",
        ifscCode: "",
        accountNo: "",
        [name]: value,
      });
    } else if (name === "selectedExpenseType") {
      setFormValues({
        ...formValues,
        selectedGym: "",
        [name]: value,
      });
    } else if (name === "selectedPayee") {
      setFormValues({
        ...formValues,
        selectedVendor: "",
        [name]: value,
      });
    } else if (name === "selectedExpenseCat") {
      // Auto-select expense type based on category's is_gym_expense field
      let autoSelectedExpenseType = "";

      if (value && value.info) {
        if (value.info.is_gym_expense === 1) {
          // If is_gym_expense = 1, auto-select "gym"
          autoSelectedExpenseType = expense_types.find(
            (type) => type.value === "gym"
          );
        } else if (value.info.is_gym_expense === 0) {
          // If is_gym_expense = 0, auto-select "wtf"
          autoSelectedExpenseType = expense_types.find(
            (type) => type.value === "wtf"
          );
        }
      }

      // For receptionists, preserve their gym selection
      const updatedFormValues = {
        ...formValues,
        selectedExpenseType: autoSelectedExpenseType,
        [name]: value,
      };

      // Only reset gym selection if not a receptionist
      if (!isReceptionist) {
        updatedFormValues.selectedGym = "";
      }

      setFormValues(updatedFormValues);
    } else {
      setFormValues({ ...formValues, [name]: value });
    }
  };

  const onChangeImages = (imageList, name) => {
    setIsSubmit(false);

    setFormImages((prevImages) => ({
      ...prevImages,
      [name]: imageList,
    }));

    if (imageList.length > 0) {
      imageList.forEach(async (image) => {
        const blob = await fetch(image?.data_url).then((res) => res.blob());
        const file = new File([blob], "filename.jpeg", { type: "image/jpeg" });

        handleUploadImage(file, userInfoData?.token, name);
      });
    }
  };

  const onChangePdf = async (event) => {
    const file = event.target.files[0];

    if (file) {
      setFormImages((prev) => ({
        ...prev,
        paymentRequestedPdf: [file],
      }));

      try {
        const result = await handleUploadImage(
          file,
          userInfoData?.token,
          "requestedImg"
        );

        if (result?.payload?.status) {
          setFormValues((prev) => ({
            ...prev,
            requestedImg:
              result?.payload?.image_url || result?.payload?.data?.url || "",
          }));
        }
      } catch (error) {
        console.error("Error uploading PDF:", error);
      }
    }
  };

  const onSubmit = () => {
    // Check petty cash limit for cluster managers
    if (
      isClusterManager &&
      formValues.selectedExpenseCat?.info?.is_petty_cash === 1 &&
      formValues.requestedAmount &&
      Number(formValues.requestedAmount) > 10000
    ) {
      toast.error("Petty cash requests cannot exceed ₹10,000 per request");
      return;
    }

    setFormErrors(
      validateExerciseForm(formValues, formImages, isEdit, userInfoData)
    );
    setIsSubmit(true);
  };

  const handleUploadImage = async (file, TOKEN, name) => {
    setIsSubmit(false);
    try {
      const actionResult = dispatch(uploadImage({ file, TOKEN }));
      const result = await actionResult;

      console.log("result=> ", result);

      if (result?.payload?.status) {
        setFormValues((prevs) => ({
          ...prevs,
          [name]:
            result?.payload?.image_url || result?.payload?.data?.url || "",
        }));
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("handleCreateNewMeal ERROR => ", error);
    }
  };

  const handleAdd = async (requestBody) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? update_expense_request : add_expense_request;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutFormData({ method, endpoint, requestBody, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        setFormValues(forminitials);
        setFormImages(imgVdoInitials);
        setIsSubmit(false);
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    setFormValues((prevs) => ({
      ...prevs,
      selectedExpenseCat:
        isEdit && rowData?.expense_category && rowData?.expense_category_name
          ? {
              label: rowData.expense_category_name,
              value: rowData.expense_category,
            }
          : "",
      selectedExpenseType:
        !isAdmin && !isClusterManager
          ? expense_types[0]
          : isClusterManager
          ? expense_types[1]
          : isEdit && rowData?.expense_type
          ? {
              label: formatWTFString(rowData.expense_category_name),
              value: rowData.expense_type,
            }
          : "",
      selectedGym:
        (!isAdmin && !isClusterManager) || isReceptionist
          ? (() => {
              if (isReceptionist && userInfoData?.gym_id) {
                // For receptionists, find gym from gymData using gym_id
                const matchingGym = gymData?.find(
                  (gym) => gym.value === userInfoData.gym_id
                );
                return matchingGym || "";
              } else {
                // For regular gym users
                return {
                  label: isGym
                    ? userInfoData?.name
                    : userInfoData?.gym_name || "",
                  value:
                    userInfoData?.gym_id ||
                    userInfoData?.user_id ||
                    userInfoData?.uid ||
                    "",
                };
              }
            })()
          : isEdit && rowData?.gym_id && rowData?.gym_name
          ? {
              label: rowData.gym_name,
              value: rowData.gym_id,
            }
          : "",
      selectedPayee:
        isEdit && rowData?.payee_type
          ? {
              label: rowData.payee_type === "self" ? "Self" : "Vendor",
              value: rowData.payee_type,
            }
          : "",
      selectedVendor:
        isEdit && rowData?.vendor_uid && rowData?.vendor_name
          ? {
              label: rowData.vendor_name,
              value: rowData.vendor_uid,
            }
          : "",
      requestedAmount:
        isEdit && rowData?.requested_amount ? rowData.requested_amount : "",
      requestedDescription:
        isEdit && rowData?.requested_description
          ? rowData.requested_description
          : isClusterManager
          ? "I need petty cash"
          : "",
      selectedPaymentMethod:
        isEdit && rowData?.payment_method
          ? {
              label: rowData.payment_method,
              value: rowData.payment_method,
            }
          : "",
      uidId: isEdit && rowData?.upi_id ? rowData.upi_id : "",
      ifscCode: isEdit && rowData?.ifsc_code ? rowData.ifsc_code : "",
      accountNo:
        isEdit && rowData?.account_number ? rowData.account_number : "",
      paymentRequestedImg:
        isEdit && rowData?.payment_method_img ? rowData.payment_method_img : "",
      requestedImg:
        isEdit && rowData?.requested_img ? rowData.requested_img : "",
    }));
  }, []);

  useEffect(() => {
    dispatch(fetchGymData(userInfoData?.token));
    getExpenseCategories();
    getVendors();
  }, []);

  useEffect(() => {
    if (expenseCategories?.status && expenseCategories?.data?.length > 0) {
      const allCats = expenseCategories.data?.map((item) => ({
        value: item.uid,
        label: item.name,
        info: item,
      }));

      setAllCategoriesData(allCats);

      // Auto-select categories only for cluster managers (only if not editing and no category selected)
      if (
        !isEdit &&
        isClusterManager &&
        (formValues.selectedExpenseCat === null ||
          !formValues.selectedExpenseCat) &&
        allCats.length > 0
      ) {
        // For cluster managers: find petty cash category
        const autoSelectedCategory = allCats.find(
          (cat) => cat.info?.is_petty_cash === 1
        );

        if (autoSelectedCategory) {
          setFormValues((prev) => ({
            ...prev,
            selectedExpenseCat: autoSelectedCategory,
          }));
        }
      }
    } else {
      setAllCategoriesData([]);
    }
  }, [
    expenseCategories,
    isClusterManager,
    isReceptionist,
    isEdit,
    formValues.selectedExpenseCat,
  ]);

  // Auto-select "Self" as payee for cluster managers
  useEffect(() => {
    if (isClusterManager && !isEdit && !formValues.selectedPayee) {
      const selfPayeeOption = {
        value: "self",
        label: "Self",
      };

      setFormValues((prev) => ({
        ...prev,
        selectedPayee: selfPayeeOption,
      }));
    }
  }, [isClusterManager, isEdit, formValues.selectedPayee]);

  // Update selectedGym for receptionists when gymData loads
  useEffect(() => {
    if (
      isReceptionist &&
      userInfoData?.gym_id &&
      gymData?.length > 0 &&
      !formValues.selectedGym
    ) {
      const matchingGym = gymData.find(
        (gym) => gym.value === userInfoData.gym_id
      );
      if (matchingGym) {
        setFormValues((prev) => ({
          ...prev,
          selectedGym: matchingGym,
        }));
      }
    }
  }, [gymData, isReceptionist, userInfoData?.gym_id]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        requested_by: userInfoData?.uid || userInfoData?.user_id || "",
        expense_category: formValues.selectedExpenseCat?.value || "",
        expense_type: formValues.selectedExpenseType?.value || "",
        gym_id: formValues.selectedGym?.value || "",
        payee_type: formValues.selectedPayee?.value || "",
        vendor_id:
          formValues.selectedPayee?.value === "vendor"
            ? formValues.selectedVendor?.value || ""
            : "",
        requested_amount: formValues.requestedAmount || "",
        requested_description: formValues.requestedDescription || "",
        payment_method: formValues.selectedPaymentMethod?.value || "",
        upi_id: formValues.uidId || "",
        ifsc_code: formValues.ifscCode || "",
        account_number: formValues.accountNo || "",
        payment_method_img: formValues.paymentRequestedImg || "",
        requested_img: formValues.requestedImg || "",
      };

      const formData = new FormData();

      for (const key in userData) {
        if (userData.hasOwnProperty(key)) {
          formData.append(key, userData[key]);
        }
      }

      //   formImages.paymentRequestedImg?.forEach((img) => {
      //     formData.append(
      //       `payment_method_img`,
      //       img.file ? img.file : rowData?.image ? "" : ""
      //     );
      //   });

      //   formImages.requestedImg?.forEach((img) => {
      //     formData.append(
      //       `requested_img`,
      //       img.file ? img.file : rowData?.image ? "" : ""
      //     );
      //   });

      if (isEdit) {
        formData.append("uid", rowData.uid);
      }

      const handleConfirm = async () => {
        handleAdd(formData);
      };

      showConfirmAlert(
        handleConfirm,
        ``,
        "Edit Form",
        `${isEdit ? "Update" : "Add New"} ${
          isClusterManager ? "Petty Cash" : "Expense"
        }`
      );
    }
  }, [isSubmit, formErrors]);

  console.log("formValues", formValues);

  // console.log("allVendorsData", allVendorsData);

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={() => setModValues(iniModvalues)}
        contentLabel="Modal"
        ariaHideApp={false}
      >
        {modValues.cardName === "add_category" ||
        modValues.cardName === "edit_category" ? (
          <ExpenseCatForm
            userInfoData={userInfoData}
            rowData={modValues.rowData}
            isEdit={modValues.cardName === "edit_category"}
            closeModal={() => setModValues(iniModvalues)}
            callFunction={() => getExpenseCategories()}
          />
        ) : modValues.cardName === "add_vendor" ||
          modValues.cardName === "edit_vendor" ? (
          <VendorForm
            userInfoData={userInfoData}
            rowData={modValues.rowData}
            isEdit={modValues.cardName === "edit_vendor"}
            closeModal={() => setModValues(iniModvalues)}
            callFunction={() => getVendors()}
            selectedExpenseCategory={formValues.selectedExpenseCat}
            allCategoriesData={allCategoriesData}
            selectedGym={formValues.selectedGym}
            gymData={gymData}
          />
        ) : null}
      </Modal>

      <div className="createNewCTOModalContainer mealsModalContainer expense-form-container">
        <CommonHeadingNBtns
          title={`${isEdit ? "Update" : "Add New"} ${
            isClusterManager ? "Petty Cash Request" : "Expense"
          }`}
          onClose={closeModal}
          onClick={onSubmit}
          btnTxt={isEdit ? "Update Request" : "Send Request"}
          isLoading={postPutLoadingFormData}
        />
        <form className="formContainer mb30">
          <div className="formInputsGrid fourGridSystem">
            {/* Hide expense category dropdown only for cluster managers since it's auto-selected */}
            {!isClusterManager && (
              <div className="formInputBox ">
                <label htmlFor="selectedExpenseCat" className="formInputLabel">
                  expense category <span className="required">*</span>
                </label>

                <div className="input-add-btn flexBetween">
                  <div
                    className={`commonWrapper ${
                      formErrors?.selectedExpenseCat && "formError"
                    }`}
                  >
                    <SelectDropdown
                      options={allCategoriesData}
                      selectedOption={formValues.selectedExpenseCat}
                      setSelectedOption={(selectedValue) =>
                        onChangeDropdown(selectedValue, "selectedExpenseCat")
                      }
                      name="Expense Category"
                    />
                  </div>

                  {isExpenseCategoryAccess && (
                    <button
                      type="button"
                      className="btn btn-dark extra-btn"
                      onClick={() =>
                        setModValues((prevs) => ({
                          ...prevs,
                          isModOpen: true,
                          cardName: "add_category",
                        }))
                      }
                    >
                      Add New
                    </button>
                  )}
                </div>
              </div>
            )}

            {/* Hide expense type dropdown for cluster managers since it's auto-selected */}
            {!isClusterManager && !isReceptionist && (
              <div className="formInputBox">
                <label htmlFor="selectedExpenseType" className="formInputLabel">
                  expense type <span className="required">*</span>
                  {formValues.selectedExpenseCat && (
                    <span className="success-text">
                      (Auto-selected based on category)
                    </span>
                  )}
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors?.selectedExpenseType && "formError"
                  }`}
                >
                  <SelectDropdown
                    options={expense_types}
                    selectedOption={formValues.selectedExpenseType}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown(selectedValue, "selectedExpenseType")
                    }
                    name="Expense Type"
                    preventKeyboardOpen={true}
                    isDisable={
                      (!isAdmin && !isClusterManager) ||
                      !!formValues.selectedExpenseCat
                    }
                  />
                </div>
              </div>
            )}

            {formValues.selectedExpenseType?.value === "gym" && (
              <div className="formInputBox">
                <label htmlFor="selectedGym" className={`formInputLabel`}>
                  gym name <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors.selectedGym ? "formError" : ""
                  }`}
                >
                  <SelectDropdown
                    options={gymData?.length > 0 ? gymData : []}
                    selectedOption={formValues.selectedGym}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown(selectedValue, "selectedGym")
                    }
                    name="Gym"
                    preventKeyboardOpen={false}
                    isDisable={
                      (!isAdmin && !isClusterManager) || isReceptionist
                    }
                  />
                </div>
              </div>
            )}

            {/* Hide payee dropdown for cluster managers since it's auto-selected as "Self" */}
            {!isClusterManager && (
              <div className="formInputBox">
                <label htmlFor="selectedPayee" className="formInputLabel">
                  pay to (payee) <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors?.selectedPayee && "formError"
                  }`}
                >
                  <SelectDropdown
                    options={expense_payee_options}
                    selectedOption={formValues.selectedPayee}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown(selectedValue, "selectedPayee")
                    }
                    name="Payee"
                    preventKeyboardOpen={true}
                  />
                </div>
              </div>
            )}

            {formValues.selectedPayee?.value === "vendor" && (
              <div className="formInputBox span2">
                <label htmlFor="selectedVendor" className="formInputLabel">
                  select vendor <span className="required">*</span>
                </label>

                <div className="input-add-btn flexBetween">
                  <div
                    className={`commonWrapper ${
                      formErrors?.selectedVendor && "formError"
                    }`}
                  >
                    <SelectDropdown
                      options={allVendorsData}
                      selectedOption={formValues.selectedVendor}
                      setSelectedOption={(selectedValue) =>
                        onChangeDropdown(selectedValue, "selectedVendor")
                      }
                      name="Vendor"
                      preventKeyboardOpen={true}
                    />
                  </div>

                  <button
                    type="button"
                    className="btn btn-dark extra-btn"
                    onClick={() =>
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        cardName: "add_vendor",
                      }))
                    }
                  >
                    Add Vendor
                  </button>
                </div>
              </div>
            )}

            <div className="formInputBox">
              <label htmlFor="requestedAmount" className="formInputLabel">
                amount (₹)<span className="required">*</span>
                <span className="helper-text">
                  {isClusterManager
                    ? "(Max ₹10,000 per petty cash request)"
                    : "(Kitna amount chahiye?)"}
                </span>
              </label>

              <input
                type="number"
                placeholder={
                  isClusterManager
                    ? "Enter Amount (Max ₹10,000)"
                    : "Enter Amount"
                }
                className={`formInput ${
                  formErrors?.requestedAmount ? "formError" : ""
                }`}
                name="requestedAmount"
                value={formValues.requestedAmount}
                onChange={onChangeInput}
                min={0}
                max={isClusterManager ? 10000 : undefined}
              />
            </div>

            {!isClusterManager && (
              <div className="formInputBox span4">
                <label
                  htmlFor="requestedDescription"
                  className="formInputLabel"
                >
                  remarks (min 20 - {formValues.requestedDescription?.length}){" "}
                  <span className="required">*</span>
                  <span className="helper-text">
                    (Kya kharida hai? Kahan se kharida hai? Detail mein
                    batayein)
                  </span>
                </label>

                <div className="commonWrapper textAreaCommonWrapper with-auto-height no-border">
                  <ReactQuill
                    id="requestedDescription"
                    name="requestedDescription"
                    className={`formInput ${
                      formErrors?.requestedDescription ? "formError" : ""
                    }`}
                    placeholder="Enter Detail.."
                    value={formValues.requestedDescription}
                    onChange={(content) =>
                      onChangeTextInput(content, "requestedDescription")
                    }
                  />
                </div>
              </div>
            )}
            <div className="formInputBox">
              <label htmlFor="selectedPaymentMethod" className="formInputLabel">
                payment method <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  formErrors?.selectedPaymentMethod && "formError"
                }`}
              >
                <SelectDropdown
                  options={expense_payment_options}
                  selectedOption={formValues.selectedPaymentMethod}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "selectedPaymentMethod")
                  }
                  name="Payment Method"
                  preventKeyboardOpen={true}
                />
              </div>
            </div>

            {/* Only show document upload type if not petty cash category */}
            {formValues.selectedExpenseCat?.info?.is_petty_cash !== 1 && (
              <div className="formInputBox">
                <label
                  htmlFor="selectedDocumentUploadType"
                  className="formInputLabel"
                >
                  document/Bill upload type
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors?.selectedDocumentUploadType && "formError"
                  }`}
                >
                  <SelectDropdown
                    options={image_pdf}
                    selectedOption={formValues.selectedDocumentUploadType}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown(
                        selectedValue,
                        "selectedDocumentUploadType"
                      )
                    }
                    name="document upload type"
                    preventKeyboardOpen={true}
                  />
                </div>
              </div>
            )}

            {formValues.selectedPaymentMethod?.value === "upi" && (
              <div className="formInputBox">
                <label htmlFor="uidId" className={`formInputLabel`}>
                  UPI Id <span className="required">*</span>
                  <span className="helper-text">
                    (UPI ID jahan payment karna hai)
                  </span>
                </label>

                <input
                  type="text"
                  placeholder="Enter UPI Id"
                  className={`formInput ${
                    formErrors?.uidId ? "formError" : ""
                  }`}
                  name="uidId"
                  value={formValues.uidId}
                  onChange={onChangeInput}
                />
              </div>
            )}

            {formValues.selectedPaymentMethod?.value === "bank" && (
              <>
                <div className="formInputBox">
                  <label htmlFor="ifscCode" className={`formInputLabel`}>
                    IFSC Code <span className="required">*</span>
                  </label>

                  <input
                    type="text"
                    placeholder="Enter IFSC Code"
                    className={`formInput ${
                      formErrors?.ifscCode ? "formError" : ""
                    }`}
                    name="ifscCode"
                    value={formValues.ifscCode}
                    onChange={onChangeInput}
                  />
                </div>

                <div className="formInputBox">
                  <label htmlFor="accountNo" className={`formInputLabel`}>
                    Bank Account Number <span className="required">*</span>
                  </label>

                  <input
                    type="number"
                    placeholder="Enter Account Number"
                    className={`formInput ${
                      formErrors?.accountNo ? "formError" : ""
                    }`}
                    name="accountNo"
                    value={formValues.accountNo}
                    onChange={onChangeInput}
                  />
                </div>
              </>
            )}
          </div>

          <div className={`formInputsGrid uploadsInputGrids`}>
            <div className="formInputBox formInputUploadBox">
              <label htmlFor="paymentRequestedImg" className="formInputLabel">
                Payment Method Image{" "}
                {formValues.selectedPaymentMethod?.value === "qr" && (
                  <span className="required">*</span>
                )}{" "}
                <span className="helper-text">
                  (UPI QR ya bank details ka screenshot)
                </span>
              </label>

              <div
                className={`commonWrapper commonUploadWrapper no-border ${
                  formErrors?.paymentRequestedImg ? "error" : ""
                }`}
              >
                <div className="icon-upload-btn createIncentiveCategoryForImageUpload">
                  <div className="icon upload-icon">
                    <CloudUploadIcon />
                  </div>
                  <div className="image">
                    <ImageUploading
                      multiple
                      value={formImages.paymentRequestedImg}
                      onChange={(imageList, addUpdateIndex) =>
                        onChangeImages(imageList, "paymentRequestedImg")
                      }
                      maxNumber={maxNumber}
                      dataURLKey="data_url"
                    >
                      {({
                        imageList,
                        onImageUpload,
                        onImageRemoveAll,
                        onImageUpdate,
                        onImageRemove,
                        isDragging,
                        dragProps,
                      }) => (
                        <div className="upload__image-wrapper">
                          {formImages.paymentRequestedImg?.length === 0 ? (
                            <>
                              <button
                                type="button"
                                style={
                                  isDragging ? { color: "red" } : undefined
                                }
                                onClick={onImageUpload}
                                {...dragProps}
                              >
                                Upload
                              </button>
                              &nbsp;
                            </>
                          ) : (
                            <>
                              {imageList.map((image, index) => (
                                <div key={index} className="image-item">
                                  <img
                                    src={image["data_url"]}
                                    alt=""
                                    width="100"
                                  />
                                  <div className="image-item__btn-wrapper">
                                    <button
                                      type="button"
                                      onClick={() => onImageUpdate(index)}
                                    >
                                      <CloudPlusIcon />
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => onImageRemove(index)}
                                    >
                                      <DeleteIcon />
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </>
                          )}
                        </div>
                      )}
                    </ImageUploading>
                  </div>
                </div>
              </div>
            </div>

            {/* Only show bill upload section if not petty cash category */}
            {formValues.selectedExpenseCat?.info?.is_petty_cash !== 1 && (
              <div className="formInputBox formInputUploadBox">
                <label htmlFor="requestedImg" className="formInputLabel">
                  upload bill Image{" "}
                  {!isEdit ? <span className="required">*</span> : null}
                  <span className="helper-text">(Bill upload karein)</span>
                </label>

                <div
                  className={`commonWrapper commonUploadWrapper no-border ${
                    formErrors?.requestedImg ? "error" : ""
                  }`}
                >
                  <div className="icon-upload-btn createIncentiveCategoryForImageUpload">
                    <div className="icon upload-icon">
                      <CloudUploadIcon />
                    </div>
                    <div className="image">
                      {formValues.selectedDocumentUploadType?.value ===
                      "pdf" ? (
                        <div>
                          <input
                            type="file"
                            accept="application/pdf"
                            onChange={onChangePdf}
                          />

                          {formValues.paymentRequestedPdf && (
                            <div>
                              <p>{formValues.paymentRequestedPdf.name}</p>
                              <button
                                type="button"
                                onClick={() => {
                                  setFormValues((prev) => ({
                                    ...prev,
                                    paymentRequestedPdf: null,
                                    requestedImg: "",
                                  }));
                                }}
                              >
                                Remove PDF
                              </button>
                            </div>
                          )}
                        </div>
                      ) : (
                        <ImageUploading
                          multiple
                          value={formImages.requestedImg}
                          onChange={(imageList, addUpdateIndex) =>
                            onChangeImages(imageList, "requestedImg")
                          }
                          maxNumber={maxNumber}
                          dataURLKey="data_url"
                        >
                          {({
                            imageList,
                            onImageUpload,
                            onImageRemoveAll,
                            onImageUpdate,
                            onImageRemove,
                            isDragging,
                            dragProps,
                          }) => (
                            <div className="upload__image-wrapper">
                              {formImages.requestedImg?.length === 0 ? (
                                <>
                                  <button
                                    type="button"
                                    style={
                                      isDragging ? { color: "red" } : undefined
                                    }
                                    onClick={onImageUpload}
                                    {...dragProps}
                                  >
                                    Upload
                                  </button>
                                  &nbsp;
                                </>
                              ) : (
                                <>
                                  {imageList.map((image, index) => (
                                    <div key={index} className="image-item">
                                      <img
                                        src={image["data_url"]}
                                        alt=""
                                        width="100"
                                      />
                                      <div className="image-item__btn-wrapper">
                                        <button
                                          type="button"
                                          onClick={() => onImageUpdate(index)}
                                        >
                                          <CloudPlusIcon />
                                        </button>
                                        <button
                                          type="button"
                                          onClick={() => onImageRemove(index)}
                                        >
                                          <DeleteIcon />
                                        </button>
                                      </div>
                                    </div>
                                  ))}
                                </>
                              )}
                            </div>
                          )}
                        </ImageUploading>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </form>
      </div>
    </>
  );
};

export default ExpenseForm;
